export const PRIVACY_POLICY_FEB_2026 = 'privacyPolicyChangeFeb2026';
export const GEOLOCATED_STATE = 'uoomGeolocation';
